var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-12"},[_c('div',{staticClass:"grid grid-cols-3 gap-12"},_vm._l((_vm.facebookPages),function(page){return _c('PageCard',{key:page.id,attrs:{"page":page}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }